import * as React from "react";
import { SVGProps } from "../types";

const YandexKassaIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <ellipse
      cx="24.907"
      cy="16.007"
      fill="#28EDBD"
      rx="4.092"
      ry="4.083"
    ></ellipse>
    <path
      fill="#0D59AF"
      d="m7.636 8 3.508-3.5c-.856.886-1.435 2.118-1.435 3.447 0 1.182.386 2.489 1.245 3.34l11.762 11.657L14.642 31l-9.245-9.225a8.154 8.154 0 0 1 .01-11.558z"
    ></path>
    <path
      fill="#1374EC"
      d="M22.734 9.056 14.66 1l-3.636 3.628c-.79.875-1.315 2.053-1.315 3.319 0 1.182.386 2.489 1.245 3.34l4.788 4.745z"
    ></path>
  </svg>
);

export { YandexKassaIcon };
